/* eslint-disable prettier/prettier */
/* eslint-disable import/no-duplicates */
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { format, parseISO } from 'date-fns';

import { Container, Button, Row, Col } from 'react-bootstrap';

import { FaPencilAlt } from 'react-icons/fa';
import { isToday } from 'date-fns/esm';
import api from '../../../services/api';

import {
  formatPrice,
  ORIGEM_PAGAMENTO,
  TIPO_USUARIO,
} from '../../../utils/funcoes';

import { useToast } from '../../../hooks/toast';
import { useClinica } from '../../../hooks/clinica';
import { useAuth } from '../../../hooks/auth';
import { usePerfil } from '../../../hooks/perfil';
import { useMedico } from '../../../hooks/medico';

import Input from '../../../components/Input';
import Select from '../../../components/Select';
import SelectSync, { IOption } from '../../../components/SelectSync';
import Loading from '../../../components/Loading';
import Tooltip from '../../../components/Tooltip';
import Modal from '../../../components/Modal';

import Conferido from './Conferido';

import getValidationErrors from '../../../utils/getValidationErrors';

import { arrayGroupBy } from '../../../utils/funcoes';

import getResponseErrors from '../../../utils/getResponseErrors';
import { IDadosPagamento } from '../../CartaoSaudeDetalhe';
import Pagamento from '../../../components/Pagamento';
import PageInfo from '../../../components/PageInfo';
import HeaderRelatorio from '../HeaderRelatorio';
import { useFormaPagamento } from '../../../hooks/formapagamento';

interface IDadosPagamentoOrigem extends IDadosPagamento {
  CprOrigem: number;
  CprPacCodigo: number;
}
interface IPagamento {
  descricao: string;
  valor: number;
  valorFormatado: string;
}

interface IRelatorio {
  CprCodigo: number;
  DataP: Date;
  DataPFormatado: string;
  CprDataPag: Date;
  CprDataPagFormatado: string;
  ehPagamentoAntecipado: boolean;
  descricao: string;
  perfil: string;
  CprHistorico: string;
  CprConferido: boolean;
  valorTotal: number;
  CprOrigem?: number;
  obs?: { texto: string; cor: string; historico?: string };
  desconto?: {
    descricao: string;
    UsuNome: string;
    valor: number;
    valorFormatado: string;
  };
  pagamento: IPagamento[];
  CprPacCodigo: number;
  doDia: boolean;
  ehEstorno: boolean;
}

interface IRelatorioFormatado {
  grupo: string;
  totalDesconto: number;
  totalDescontoFormatado: string;
  total: number;
  totalFormatado: string;
  dados: IRelatorio[];
}

interface ITotais {
  totalDescontoFormatado: string;
  totalFormatado: string;
  totalAntecipadoFormatado: string;
}

interface IFormBusca {
  dataInicio: Date;
  dataFim: Date;
  CliCodigo: string;
  PerCodigo: string;
  ConUsuCodigo: string;
  formaPagto: string;
}

interface IDataExibe {
  dataHora: string;
  dataDiaSemana: string;
}

type pageProps = {
  tipo: string;
};

const FechamentoDia: React.FC<pageProps> = ({ tipo }) => {
  const history = useHistory();
  const { addToast } = useToast();
  const { user } = useAuth();
  const { optionsClinica } = useClinica();

  const { optionsPerfil, buscaPerfil } = usePerfil();
  const { optionsMedico, buscaOptionsMedico } = useMedico();
  const { optionsFormasPagamento, buscaFormaPagamento } = useFormaPagamento();

  const [optionPerfil, setOptionsPerfil] = useState<IOption[]>([]);

  const formRefBusca = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [showModalPagamento, setShowModalPagamento] = useState(false);
  const [dadosPagamento, setDadosPagamento] = useState<
    IDadosPagamentoOrigem | undefined
  >();
  const [dadosRelatorio, setDadosRelatorio] = useState<IRelatorioFormatado[]>();
  const [totais, setTotais] = useState<ITotais>();
  const initialData = {
    dataInicio: format(new Date(), 'yyyy-MM-dd'),
    dataFim: format(new Date(), 'yyyy-MM-dd'),
    CliCodigo: user.UsuClinica.toString(),
  };
  const [dataExibe, setDataExibe] = useState<IDataExibe>();
  const [clinica, setClinica] = useState('');

  const paginaTipo =
    tipo && tipo === 'fechamentoconferencia'
      ? {
        titulo: 'Fechamento Conferencia',
        tipoConferencia: true,
      }
      : { titulo: 'Fechamento do Dia', tipoConferencia: false };

  const exibeTotais = user.UsuTipo <= TIPO_USUARIO.SUPERVISOR;
  const exibeConferencia =
    paginaTipo.tipoConferencia && user.UsuTipo <= TIPO_USUARIO.SUPERVISOR;

  const informacoesPagina = paginaTipo.tipoConferencia
    ? `<b>Descrição:</b> Relatório para conferencia de todos os pagamentos realizados no dia.<br /> Quando estiver sendo realizado no dia corrente, habilita o campo de edição para que possa ser realizado ajuste no lançamento.`
    : `<b>Descrição:</b> Exibe todos os pagamentos realizados em um determinado período`;

  useEffect(() => {
    async function loadPerfis(): Promise<void> {
      await buscaPerfil();
    }
    if (!optionsPerfil || Object.keys(optionsPerfil).length === 0) loadPerfis();
  }, [buscaPerfil, optionsPerfil]);

  useEffect(() => {
    async function loadMedicos(): Promise<void> {
      await buscaOptionsMedico();
    }
    if (!optionsMedico || Object.keys(optionsMedico).length === 0)
      loadMedicos();
  }, [buscaOptionsMedico, optionsMedico]);

  useEffect(() => {
    async function loadFormaPagto(): Promise<void> {
      await buscaFormaPagamento();
    }
    if (
      !optionsFormasPagamento.optionFormaPagamento ||
      Object.keys(optionsFormasPagamento.optionFormaPagamento).length === 0
    )
      loadFormaPagto();
  }, [buscaFormaPagamento, optionsFormasPagamento]);

  useEffect(() => {
    try {
      setOptionsPerfil(optionsPerfil.optionPerfis);
    } catch (error) {
      addToast({
        title: 'Não foi possível buscar perfis',
        type: 'error',
      });
    }
  }, [addToast, optionsPerfil]);

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.SUPERVISOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const handleSubmitBusca = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        formRefBusca.current?.setErrors({});
        const schema = Yup.object().shape({
          dataInicio: Yup.date().required(),
          ...(exibeConferencia ? {} : { dataFim: Yup.date().required() }),
          CliCodigo: Yup.string().required(),
          PerCodigo: Yup.string().nullable(true),
          ConUsuCodigo: Yup.string().nullable(true),
          formaPagto: Yup.string().nullable(true),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        setClinica(
          optionsClinica.find(cli => cli.value === dados.CliCodigo)?.label ||
          '',
        );

        const dataInicioSelecionada = parseISO(dados.dataInicio.toString());
        const dataFimSelecionada = exibeConferencia
          ? dataInicioSelecionada
          : parseISO(dados.dataFim.toString());

        const dataInicioFormatada = format(dataInicioSelecionada, 'yyyy-MM-dd');
        const dataFimFormatada = format(dataFimSelecionada, 'yyyy-MM-dd');

        setDataExibe({
          dataDiaSemana: `${format(
            dataInicioSelecionada,
            'dd/MM/yyyy',
          )} até ${format(dataFimSelecionada, 'dd/MM/yyyy')}`,
          dataHora: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
        });

        let parametrosOpcionais = dados.ConUsuCodigo
          ? `&ConUsuCodigo=${dados.ConUsuCodigo}`
          : '';
        parametrosOpcionais += dados.PerCodigo
          ? `&PerCodigo=${dados.PerCodigo}`
          : '';
        parametrosOpcionais += dados.formaPagto
          ? `&formaPagto=${dados.formaPagto}`
          : '';

        const response = await api.get<IRelatorio[]>(
          `/relatorios/fechamentodia?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}&CliCodigo=${dados.CliCodigo}${parametrosOpcionais}`,
        );

        let totalGeral = 0;
        let totalGeralDesconto = 0;
        let totalGeralAntecipado = 0;

        const dadosFormatados = response.data.map(rel => {
          const DataPFormatado = format(
            parseISO(rel.DataP.toString()),
            'dd/MM/yyyy',
          );
          const CprDataPagFormatado = format(
            parseISO(rel.CprDataPag.toString()),
            'dd/MM/yyyy',
          );

          const ehPagamentoAntecipado = DataPFormatado !== CprDataPagFormatado;
          if (ehPagamentoAntecipado) totalGeralAntecipado += rel.valorTotal;

          const doDia = isToday(dataInicioSelecionada);
          let ehEstorno = false;

          const desconto = rel.desconto
            ? {
              ...rel.desconto,
              valorFormatado: formatPrice(rel.desconto.valor),
            }
            : undefined;
          let obs;
          if (rel.valorTotal < 0) {
            ehEstorno = true;
            obs = {
              texto: 'ESTORNO',
              historico:
                desconto && desconto.valor < 0
                  ? `USUÁRIO: ${desconto.UsuNome}, DESCRIÇÃO: ${desconto.descricao}`
                  : undefined,
              cor: 'text-danger',
            };
          } else if (desconto && desconto.valor !== 0) {
            obs = {
              texto: desconto.valorFormatado,
              historico: `USUÁRIO: ${desconto.UsuNome}, DESCRIÇÃO: ${desconto.descricao}`,
              cor: '',
            };
          } else if (rel.valorTotal === 0) {
            if (rel.perfil.includes('ECG') || rel.perfil.includes('EXAMES')) {
              // obs = {
              //   texto: 'GRATUITO',
              //   historico: undefined,
              //   cor: 'text-success',
              // };
              obs = {
                texto: rel.CprHistorico,
                historico: undefined,
                cor: 'text-info',
              };
            } else if (rel.CprHistorico.includes('RETORNO')) {
              obs = {
                texto: 'RETORNO',
                historico: undefined,
                cor: 'text-info',
              };
            } else {
              obs = {
                texto: rel.CprHistorico,
                historico: undefined,
                cor: 'text-info',
              };
            }
          } else {
            obs = undefined;
          }

          return {
            ...rel,
            DataPFormatado,
            CprDataPagFormatado,
            descricao:
              rel.perfil === '0 - CARTÃO + SAÚDE'
                ? `${rel.descricao} - ${rel.CprHistorico}`
                : rel.descricao,
            CprOrigem:
              rel.perfil === '0 - CARTÃO + SAÚDE'
                ? ORIGEM_PAGAMENTO.CARTAO
                : ORIGEM_PAGAMENTO.CONSULTAS,
            ehPagamentoAntecipado,
            obs,
            pagamento: rel.pagamento
              ? rel.pagamento.map(des => {
                return { ...des, valorFormatado: formatPrice(des.valor) };
              })
              : [{ descricao: '', valor: 0, valorFormatado: 'R$ 0,00' }],
            desconto,
            ehEstorno,
            doDia,
          };
        });

        const ordenado = arrayGroupBy(dadosFormatados, i => i.perfil);

        const ordenadoFormatado = ordenado.map(ord => {
          const totalDesconto = ord.reduce((tot, item) => {
            if (!item.ehEstorno) return tot + Number(item.desconto?.valor || 0);
            return tot;
          }, 0);
          totalGeralDesconto += totalDesconto;

          const total = ord.reduce((tot, item) => {
            return tot + Number(item.valorTotal);
          }, 0);
          totalGeral += total;

          return {
            grupo: ord[0].perfil,
            totalDesconto,
            totalDescontoFormatado: formatPrice(totalDesconto),
            total,
            totalFormatado: formatPrice(total),
            dados: ord,
          };
        });

        setDadosRelatorio(ordenadoFormatado);
        setTotais({
          totalFormatado: formatPrice(totalGeral),
          totalAntecipadoFormatado: formatPrice(totalGeralAntecipado),
          totalDescontoFormatado: formatPrice(totalGeralDesconto),
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagem = getResponseErrors(error);
          addToast({
            type: 'error',
            title: 'Não foi possível carregar dados',
            description: mensagem,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [addToast, optionsClinica, exibeConferencia, paginaTipo.tipoConferencia],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  const handlePagamento = useCallback((dados: IDadosPagamentoOrigem) => {
    setDadosPagamento(dados);

    setShowModalPagamento(true);
  }, []);

  const handleFecharModalPagamento = useCallback(async (load: boolean) => {
    setShowModalPagamento(false);
    if (load) {
      formRefBusca.current?.submitForm();
      setDadosPagamento(undefined);
    }
  }, []);

  const handleSetConferido = useCallback(
    (cprCodigo: number, conferido: boolean) => {
      const novoArray = dadosRelatorio?.map(itens => {
        const novosDados = itens.dados.map(dados => {
          if (dados.CprCodigo === cprCodigo)
            return { ...dados, CprConferido: conferido };
          return dados;
        });
        return { ...itens, dados: novosDados };
      });
      setDadosRelatorio(novoArray);
    },
    [dadosRelatorio],
  );

  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}
      {showModalPagamento && (
        <Modal
          show={showModalPagamento}
          titulo={dadosPagamento?.tituloPagamento || ''}
          handleFecharModal={() => setShowModalPagamento(false)}
        >
          <Pagamento
            handleFechar={handleFecharModalPagamento}
            tipo={
              dadosPagamento?.CprOrigem?.toString() ||
              ORIGEM_PAGAMENTO.CONSULTAS.toString()
            }
            cprCodigo={dadosPagamento?.pagamentoSelecionado}
            pacCodigo={
              dadosPagamento && dadosPagamento.CprPacCodigo > 0
                ? dadosPagamento.CprPacCodigo
                : undefined
            }
          />
        </Modal>
      )}
      <>
        <div className="d-print-none bg-white border p-2 mb-2">
          <div className="p-2 mb-2 d-flex justify-content-between">
            <h2 id="topoBusca">{paginaTipo.titulo}</h2>
            <PageInfo
              descricao={informacoesPagina}
              permissao={TIPO_USUARIO.SUPERVISOR}
            />
          </div>
          {optionsClinica.length > 0 && user && (
            <Form
              ref={formRefBusca}
              initialData={initialData}
              onSubmit={handleSubmitBusca}
            >
              <Row>
                <Col md={2}>
                  <Input name="dataInicio" label="De" type="date" required />
                </Col>
                {!paginaTipo.tipoConferencia && (
                  <Col md={2}>
                    <Input name="dataFim" label="Até" type="date" required />
                  </Col>
                )}
                <Col md={2}>
                  <SelectSync
                    name="PerCodigo"
                    label="Perfil"
                    options={optionPerfil}
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col>
                <Col md={2}>
                  <SelectSync
                    name="ConUsuCodigo"
                    label="Médico"
                    options={optionsMedico}
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col>

                <Col md={2}>
                  <SelectSync
                    name="formaPagto"
                    label="Forma de Pagamento"
                    options={optionsFormasPagamento.optionFormaPagamento}
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col>
                <Col md={2}>
                  <Select
                    name="CliCodigo"
                    label="Clinica"
                    options={optionsClinica}
                    disabled={user.UsuTipo !== TIPO_USUARIO.ADMINISTRADOR}
                  />
                </Col>
                <Col md={2}>
                  <br />
                  <Button type="submit" size="sm" variant="outline-secondary">
                    BUSCAR
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>

        <HeaderRelatorio
          dataImpressao={dataExibe?.dataHora}
          titulo={`${paginaTipo.titulo.toUpperCase()} ${clinica.length > 0 ? `- ${clinica} -` : '-'
            } ${dataExibe?.dataDiaSemana || ''}`}
        />

        <div className="bg-white border p-2">
          {dadosRelatorio && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th>Data</th>
                    <th>Descrição</th>
                    <th style={{ minWidth: '150px' }}>Desconto</th>
                    <th style={{ minWidth: '125px' }}>Pagamento</th>
                    <th style={{ minWidth: '115px' }}>Valor</th>
                    {exibeConferencia && (
                      <>
                        <th style={{ minWidth: '70px' }}>Conferido</th>
                        <th style={{ minWidth: '70px' }}> - </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {dadosRelatorio &&
                    dadosRelatorio.map(rel => (
                      <React.Fragment key={`des-${rel.grupo}`}>
                        <tr
                          style={{
                            fontSize: 'Small',
                            height: '30px',
                            fontWeight: 'bold',
                          }}
                        >
                          <td colSpan={exibeTotais ? 2 : 5}>{rel.grupo}</td>
                          {exibeTotais && (
                            <>
                              <td>Total Desc: {rel.totalDescontoFormatado}</td>
                              <td>Nº Registros: {rel.dados.length}</td>
                              <td>Total: {rel.totalFormatado}</td>
                            </>
                          )}

                          {exibeConferencia && (
                            <>
                              <td />
                              <td />
                            </>
                          )}
                        </tr>
                        {rel.dados.map(relatorio => (
                          <tr
                            key={`despesas-${rel.grupo}-${relatorio.CprCodigo}`}
                            data-id={relatorio.CprCodigo}
                            style={{ fontSize: '.7rem', height: '30px' }}
                            className={
                              relatorio.ehPagamentoAntecipado
                                ? 'text-muted'
                                : ''
                            }
                          >
                            <td>{relatorio.DataPFormatado}</td>
                            <td>{relatorio.descricao}</td>
                            <td>
                              {relatorio.obs &&
                                (relatorio.obs.historico ? (
                                  <Tooltip
                                    className={relatorio.obs.cor}
                                    title={relatorio.obs.historico}
                                  >
                                    {relatorio.obs.texto}
                                  </Tooltip>
                                ) : (
                                  <span className={relatorio.obs.cor}>
                                    {relatorio.obs.texto}
                                  </span>
                                ))}
                            </td>
                            <td>
                              {relatorio.pagamento.map(pag => (
                                <span
                                  key={`pagD-${relatorio.CprCodigo}-${pag.descricao}`}
                                  className="d-block"
                                >
                                  {pag.descricao}
                                </span>
                              ))}
                            </td>
                            <td>
                              {relatorio.pagamento.map(pag => (
                                <span
                                  key={`pagV-${relatorio.CprCodigo}-${pag.descricao}`}
                                  className="d-block"
                                >
                                  {pag.valorFormatado}
                                </span>
                              ))}
                            </td>
                            {exibeConferencia && (
                              <>
                                <td>
                                  <Conferido
                                    CprCodigo={relatorio.CprCodigo}
                                    CprConferido={relatorio.CprConferido}
                                    handleConferir={handleSetConferido}
                                  />
                                </td>
                                <td>
                                  <Button
                                    type="button"
                                    variant="primary-outline"
                                    className={`py-0 ${(relatorio.doDia &&
                                      !relatorio.ehEstorno &&
                                      exibeTotais &&
                                      !relatorio.CprConferido) ||
                                      user.UsuCodigo === 1
                                      ? ''
                                      : 'd-none'
                                      }`}
                                    title={`${relatorio.CprCodigo}`}
                                    onClick={
                                      () =>
                                        handlePagamento({
                                          CprOrigem:
                                            relatorio.CprOrigem ||
                                            ORIGEM_PAGAMENTO.CONSULTAS,
                                          tituloPagamento: `${relatorio.descricao}`,
                                          pagamentoSelecionado:
                                            relatorio.CprCodigo,
                                          CprPacCodigo: relatorio.CprPacCodigo,
                                        })
                                      // eslint-disable-next-line react/jsx-curly-newline
                                    }
                                  >
                                    <FaPencilAlt />
                                  </Button>
                                </td>
                              </>
                            )}
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  {exibeTotais && (
                    <tr
                      key="fdfdsfsdfdf"
                      style={{
                        fontSize: 'Small',
                        height: '30px',
                        fontWeight: 'bold',
                      }}
                    >
                      <td colSpan={2} style={{ textAlign: 'right' }}>
                        {totais?.totalAntecipadoFormatado !== 'R$0,00'
                          ? `Total Antecipado: ${totais?.totalAntecipadoFormatado}`
                          : ''}
                      </td>
                      <td>Total Desc: {totais?.totalDescontoFormatado}</td>
                      <td colSpan={2} style={{ textAlign: 'right' }}>
                        Total Geral: {totais?.totalFormatado}
                      </td>
                      {exibeConferencia && (
                        <>
                          <td />
                          <td />
                        </>
                      )}
                    </tr>
                  )}
                </tbody>
              </table>
            </>
          )}
        </div>
      </>
    </Container>
  );
};

export default FechamentoDia;
